// notification/actions.js

import { notificationInitialState } from "./notificationState";

export const makeNotificationActions = (set, get) => ({
  showNotification: (payload) =>
    set((s) => ({
      notification: {
        isActive: true,
        type: payload.type,
        title: payload.title,
        message: payload.message || "",
        errors: payload.errors || null,
        displayMessages: payload.displayMessages || null,
      },
    })),
  hideNotification: () =>
    set((s) => ({ notification: { ...s.notification, isActive: false } })),
  resetNotification: () => set({ notification: notificationInitialState }),
});
